import React from 'react';
import { Grid, Switch, Typography } from '@mui/material';
import { numberWithCommas } from 'utility';
import jMoment from 'moment-jalaali';
import useCustomHook from '../../hooks';
import { PriceLabel } from 'components';

export const VOUCHER_TYPES = {
  1: 'شارژ اعتبار',
  2: 'تخفیف مبلغی',
  4: 'تخفیف درصدی - یکبار مصرف برای یک آیتم',
  8: 'تخفیف درصدی - بدون محدودیت',
  16: 'تخفیف درصدی - یکبار مصرف برای یک فاکتور',
};

export const FILTER_VOUCHER_TYPES = {
  2: 'تخفیف مبلغی',
  4: 'تخفیف درصدی - یکبار مصرف برای یک آیتم',
  8: 'تخفیف درصدی - بدون محدودیت',
  16: 'تخفیف درصدی - یک بار مصرف برای یک فاکتور',
};

const PERCENTAGE_VOUCHER_INDEXES = [4, 8, 16];

const columns = (SeeDetailBtn, onChangeStatus = () => { }, actionsList, currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'نام بن',
    field: 'name',
    filtering: false,
    sorting: false,
  },
  {
    title: 'حساب تفصیلی',
    field: 'guild',
    filtering: false,
    sorting: false,
    render: (rd) => rd?.guild?.name ?? '-',
  },
  {
    title: 'نوع بن',
    field: 'type',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => VOUCHER_TYPES[rd?.type] ?? '-',
  },
  {
    title: 'میزان صادر شده',
    field: 'creditAmount',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rc) =>
      PERCENTAGE_VOUCHER_INDEXES.includes(rc?.type)
        ? rc?.discountPercentage
          ? `${numberWithCommas(rc?.discountPercentage)}٪`
          : ''
        : <PriceLabel amount={rc?.creditAmount} currency={currencyText}/>,
  },
  {
    title: `مقدار استفاده شده (${currencyText})`,
    field: 'usedAmount',
    align: 'center',
    sorting: false,
    filtering: false,
    render: (rc) => numberWithCommas(rc?.usedAmount),
  },
  {
    title: 'تاریخ انقضا',
    field: 'expireDate',
    filtering: false,
    sorting: false,
    render: (rc) => jMoment(rc?.expireDate).format('dddd, jD jMMMM jYYYY'),
  },
  {
    title: 'کد تخفیف',
    field: 'hash',
    align: 'center',
    filtering: false,
    sorting: false,
    cellStyle: {
      fontFamily: 'Vazir',
    },
  },

 ...(actionsList['voucherToggleStatusAction'] ? [{
    title: 'تغییر وضعیت',
    field: 'active', // 1384
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => <ToggleStatus rd={rd} onChangeStatus={onChangeStatus} />,
  }] : []),
 ...(actionsList['voucherDetailAction'] ? [{
    title: 'عملیات',
    field: 'operation',
    filtering: false,
    align: 'center',
    sorting: false,
    render: (rd) => (SeeDetailBtn ? <SeeDetailBtn id={rd?.id} /> : <div />),
  }] : []),
];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

const orderingIndexes = [
  null,
  'زمان شروع',
  'زمان انقضا',
  'نام و نام خانوادگی',
  'میزان',
  'استفاده شده',
  'تعداد شارژ مجدد',
  'وضعیت',
  null,
  null,
  null,
];

const ToggleStatus = ({ rd, onChangeStatus }) => {
  const { loading, setLoading } = useCustomHook();
  return (
    <Grid container alignItems="center" justifyContent="center" style={{ opacity: loading ? 0.4 : 1 }}>
      <Switch
        disabled={loading}
        color="primary"
        onChange={async () => {
          setLoading(true);
          await onChangeStatus(rd?.id, !rd?.active);
          setLoading(false);
        }}
        checked={rd?.active}
        className='iosSwitch'
      />
      <Typography>{rd?.active ? 'فعال' : 'غیرفعال'}</Typography>
    </Grid>
  );
};

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, columnsId, generateData, orderingIndexes };
